import { CommonModule } from "@angular/common";
import { NgModule } from '@angular/core';;
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgbPaginationModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { CustomPipesModule } from "../../shared/custom-pipes/custom-pipes.module";
import { HtmlRendrerModule } from "../html-rendrer/html-rendrer.module";
import { ScheduleEventWidgetComponent } from "./schedule-event-widget.component";
import { InViewportModule } from "../in-viewport";
import { DateRangeFilterModule } from 'app/shared-modules/date-range-filter/date-range-filter.module';


@NgModule({
    declarations: [
        ScheduleEventWidgetComponent,
    ],
    imports: [
        InViewportModule,
        CustomPipesModule,
        CommonModule,
        RouterModule,
        NgbPaginationModule,
        HtmlRendrerModule,
        FormsModule,
        NgSelectModule,
        DateRangeFilterModule
    ],
    exports: [
        ScheduleEventWidgetComponent,
    ]
})

export class ScheduleEventWidgetModule { }